module.exports = __webpack_public_path__ + "img/20190806182745.63b97f59.png";